import Paper from "@mui/material/Paper";
import { PaperProps } from "@mui/material";

import { styled } from "@mui/material/styles";

const OutlinedPaperStyled = styled(Paper)(({ theme }) => ({
  borderColor: theme.palette.grey[200],
}));

export const OutlinedPaper: React.FC<PaperProps> = (props) => {
  return <OutlinedPaperStyled {...props} variant="outlined" />;
};
